import React, {Component} from 'react';
import { IntercomAPI } from 'react-intercom';
import NavbarComponent from '../../shared/navbar/components/NavbarComponent';

import Box from '../../shared/box/components/BoxComponent';

import "../styles/LandingComponents.scss";
import LightBoxComponent from "../../../shared/lightbox/components/LightBoxComponent";
import RegisterModalComponent from "../../../shared/registermodal/components/RegisterModalComponent";

import LoginComponent from "../../../shared/Login/components/LoginComponent";

import OurBrandsComponent from '../../shared/ourBrands/components/OurBrandsComponent';
import OurRetailersComponent from '../../shared/ourRetailers/components/OurRetailersComponent';
import OurPlatformComponent from '../../shared/ourPlatform/components/OurPlatformComponent';
import Subscribe from '../../shared/subscribe/components/Subscribe';
import FooterComponent from "../../../shared/footer/components/FooterComponent";

import ScrollableAnchor, {configureAnchors} from 'react-scrollable-anchor'
import HighlightA from '../../../shared/highlights/components/highlightA/HighlightA';
import HighlightB from '../../../shared/highlights/components/highlightB/HighlightB';
import axios from "axios";
import LoadingComponent from "../../../shared/loading/components/LoadingComponent";
import Hero from '../../shared/hero/components/Hero';

import { withTranslation } from 'react-i18next';

class LandingComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLogin: false,
            showRegister: false,
            registerCompanyType: '',
            landing: [],
            loading: true,
            renderHighlight: ""
        };

        this.closeRegister = this.closeRegister.bind(this);
        this.openRegister = this.openRegister.bind(this);
        this.openLogin = this.openLogin.bind(this);
        this.closeLogin = this.closeLogin.bind(this);
    }

    componentWillMount() {
        configureAnchors({
            offset: -120, scrollDuration: 1000
        });
    }

    openLogin() {
        this.setState({
            showLogin: true
        });
    }

    closeLogin() {
        this.setState({
            showLogin: false
        });
    }

    openRegister(companyType = '') {
        this.setState({
            registerCompanyType: companyType,
            showRegister: true
        });
    }

    closeRegister() {
        this.setState({
            showRegister: false
        })
    }

    chooseHighlight(text) {
        const random = Math.floor(Math.random() * 2) + 1;
        return random % 2 === 0 ? <HighlightA
                text={text}
                open={this.openLogin.bind(this)}/> :
            <HighlightB
                open={this.openLogin.bind(this)}
                text={text}
            />
    }

    async getLanding() {
        let result = await axios.get(`api/landing/`);
        let response = await result.data;

        this.setState({
            landing: response,
            loading: false,
            renderHighlight: this.chooseHighlight(response.spotlight)
        })
    }

    componentDidMount() {
        IntercomAPI('update', 'landing_page');
        this.getLanding();
    }

    render() {

        if(this.state.loading) {
            return <LoadingComponent />;
        }

        let retailers_section;
        if (this.props.t('lang') !== 'pt_BR') {
            retailers_section =  (<>
                <section id="our-retailers">
                    <ScrollableAnchor id={'ourretailers'}>
                        <h3 className="title">{this.props.t('OUR RETAILERS')}</h3>
                    </ScrollableAnchor>
                    <p className="description">
                        {this.state.landing.our_retailers_text}
                    </p>
                </section>
                <section id="our-retailers-slider">
                    <OurRetailersComponent/>
                </section>
            </>);
        }
        

        return (
            <div id="landing-page">
                <NavbarComponent
                    showLogin={() => this.openLogin()} />
                {this.state.showRegister &&

                <RegisterModalComponent companyType={this.state.registerCompanyType} close={this.closeRegister}/>
                }

                {this.state.showLogin &&
                <LightBoxComponent isOpen={this.state.showLogin} handleClick={() => this.closeLogin()}
                                   handleEventClose={() => this.closeLogin()}
                >
                    <LoginComponent
                    closeRegister={this.closeRegister}
                    OpenRegister={this.openRegister.bind(this)}/>
                </LightBoxComponent>
                }
                { this.state.landing &&
                    <Hero open={this.openLogin.bind(this)} openRegister={this.openRegister.bind(this)} data={this.state.landing.hero} />
                }
                <section id="address">
                    <p>{this.state.landing.address1}</p>
                    <p>{this.state.landing.address2}</p>
                </section>
                <section id="login-register-mobile">
                    <button onClick={() => this.setState({showRegister: true})} className="link register">{this.props.t('REGISTER')}
                    </button>
                    <button className="link login" onClick={() => this.openLogin()}> {this.props.t('LOGIN')}</button>
                </section>
                <div className="container">
                    <section id="register">
                        <ScrollableAnchor id='register'>
                            <h3 className="title hd-mb">{this.props.t('REGISTER')}</h3>
                        </ScrollableAnchor>
                        <p className="description hd-mb">
                            {this.state.landing.register_text || ""}
                        </p>
                        <div className="who-are-you-separator"/>
                        <div className="who-are-you-text hd-mb">{this.props.t('Who are you?')}</div>
                        <div className="boxes">
                            <Box onClick={this.openRegister} companyType="b" title={this.props.t('Retailer')}
                                 image={`${process.env.PUBLIC_URL}/images/landing/Retailer.png`}/>
                            <Box onClick={this.openRegister} companyType="s" title={this.props.t('Brand')}
                                 image={`${process.env.PUBLIC_URL}/images/landing/Brand.png`}/>
                        </div>
                    </section>
                    <section id="our-brands">
                        <ScrollableAnchor id={'ourbrands'}>
                            <h3 className="title">{this.props.t('OUR BRANDS')}</h3>
                        </ScrollableAnchor>
                        <p className="description">
                            {this.state.landing.our_brands_text || ""}
                        </p>
                        <OurBrandsComponent openLogin={this.openLogin} openRegister={this.openRegister}/>
                    </section>
                    <section id="our-platform">
                        <ScrollableAnchor id='ourplatform'>
                            <h3 className="title">
                                <span className="hd-mb">{this.props.t('navbar_item_2_uc')}</span>
                                <span className="show-mb">{this.props.t('HOW IT WORKS')}</span>
                            </h3>
                        </ScrollableAnchor>
                        <p className="description">
                          {this.state.landing.our_platform_text || ""}
                        </p>
                        <OurPlatformComponent
                            retailers={this.state.landing.our_platform_retailers}
                            ourPlataform={this.state.landing.our_platform_our_platform}
                            brands={this.state.landing.our_platform_brands}
                            openRegister={this.openRegister}
                        />
                    </section>
                    {retailers_section}
                    
                </div>
                <Subscribe text={this.state.landing.subscribe}/>
                <FooterComponent/>
            </div>
        );
    }
}

export default withTranslation()(LandingComponent)
